import { Routes, Route, Navigate } from 'react-router-dom';
import './admin.css';
import ProtectedAdminRoute from './ProtectedAdminRoute';
import AdminLogin from './AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminInquiries from './pages/AdminInquiries';
import AdminBanners from './pages/AdminBanners';
import AdminGalleries from './pages/AdminGalleries';
import AdminOurWork from './pages/AdminOurWork';
import AdminVanity from './pages/AdminVanity';
import AdminInstagram from './pages/AdminInstagram';
import AdminTestimonials from './pages/AdminTestimonials';
import AdminFAQs from './pages/AdminFAQs';
import AdminPasscodes from './pages/AdminPasscodes';
import AdminHomeContent from './pages/AdminHomeContent';
import AdminAboutContent from './pages/AdminAboutContent';
import AdminBlogs from './pages/AdminBlogs';
import AdminBlogEditor from './pages/AdminBlogEditor';

export default function AdminApp() {
  return (
    <Routes>
      <Route path="login" element={<AdminLogin />} />
      <Route path="*" element={
        <ProtectedAdminRoute>
          <Routes>
            <Route index element={<AdminDashboard />} />
            <Route path="inquiries" element={<AdminInquiries />} />
            <Route path="banners" element={<AdminBanners />} />
            <Route path="galleries" element={<AdminGalleries />} />
            <Route path="ourwork" element={<AdminOurWork />} />
            <Route path="vanity" element={<AdminVanity />} />
            <Route path="instagram" element={<AdminInstagram />} />
            <Route path="testimonials" element={<AdminTestimonials />} />
            <Route path="faqs" element={<AdminFAQs />} />
            <Route path="passcodes" element={<AdminPasscodes />} />
            <Route path="home-content" element={<AdminHomeContent />} />
            <Route path="about-content" element={<AdminAboutContent />} />
            <Route path="blogs" element={<AdminBlogs />} />
            <Route path="blogs/:id" element={<AdminBlogEditor />} />
            <Route path="*" element={<Navigate to="/admin" replace />} />
          </Routes>
        </ProtectedAdminRoute>
      } />
    </Routes>
  );
}
